<template>
  <v-btn color="indigo" dark="" class="mr-5 mb-2" @click="makeWorkingHoursExcel()">
    Excel
    <v-icon right>mdi-microsoft-excel</v-icon>
  </v-btn>
</template>

<script>
import XLSX from 'sheetjs-style';

export default {
  name: 'WorkingHoursExcelExport',
  props: {
    excel_data: {
      type: Array
    },
    name: {
      type: String
    },
  },
  data: () => ({}),
  computed: {
    comp_WorkingHours() {
      return this.excel_data
    }
  },
  methods: {
    getFunctionName(id) {
      const map = { 1: "Schütze", 2: "Standaufsicht", 3: "Schießsportleiter" };
      return map[id] || "Unbekannt";
    },
    makeWorkingHoursExcel() {

      let ExcelName = 'Arbeitsstunden von ' + this.name;
      ExcelName = ExcelName.replaceAll('.', '');
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      var Data = [];
      this.comp_WorkingHours.forEach(e => {
        var temp = [];
          temp.push({
            'Verein': this.name,
          });

        temp.map(i => {
              i['Name'] = e.user_name,
              i['Vorname'] = e.user_vorname,
              i['Mitgliedsnummer'] = e.user_mitgliednummer,
              i['Datum'] = new Date(e.Datum).toLocaleString([], {dateStyle: 'short'}),
              i['Stunden'] = e.stunden,
              i['Beginn'] = new Date(e.beginn).toLocaleString([], {dateStyle: 'short', timeStyle: 'short'}),
              i['Ende'] = new Date(e.ende).toLocaleString([], {dateStyle: 'short', timeStyle: 'short'}),
              i['Funktion'] = e.shooting_function_name || e.funktion_name || (isNaN(e.funktion) ? e.funktion : this.getFunctionName(e.shooting_function_id || e.funktion)),
              i['Standnamen'] = e.standnamen,
              i['Beschreibung'] = e.Beschreibung
        });

        Data.push(...temp);
      })

      var shootingbookWS = XLSX.utils.json_to_sheet(Data);

      const CellOptions = {
        font: {
          name: 'Arial',
          sz: 10,
          bold: true,
          color: {rgb: "FFFFFFFF"}
        },
        fill: {
          bgColor: {rgb: "FF59AB44"},
          fgColor: {rgb: "FF59AB44"},
        },
        alignment: {
          wrapText: true
        },
      };

      // Hier wird die Range der Tabelle decodiert
      var range = XLSX.utils.decode_range(shootingbookWS['!ref']);
      // Hier wird herausgefunden, welche Adresse zu welchem Zellen/Spalten Namen gehört
      // Dann können Optionen an die entsprechende Zellen/Spalten gehängt werden.
      for (var R = range.s.r; R <= range.e.r; ++R) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          // Zell Adressen für alle Zellen über alle Spalten
          // var cell_address = {c:C, r:R};
          // Zell Adressen nur in der 1 Zeile / Zeile ist r beginnend bei 0 / c ist die Spalte auch bei 0 beginnend.
          var cell_Header_Address = {c: C, r: 0};
          var cell_ref = XLSX.utils.encode_cell(cell_Header_Address);
          // Hänge an jede Spalte in Zeile 1 die Optionen dran.
          shootingbookWS[cell_ref].s = CellOptions;
        }
      }

      XLSX.utils.book_append_sheet(wb, shootingbookWS, 'Arbeitsstunden') // sheetAName is name of Worksheet

      // export Excel file
      XLSX.writeFile(wb, ExcelName + '.xlsx') // name of the file is 'book.xlsx'

    }
  },
}
</script>

<style scoped>

</style>